<template>
  <div>
    <modal
      :show.sync="previewEmbedded"
      scrollable
      header-classes="bg-primary p-2 flex items-center"
      hide-footer
      size="lg"
      bodyClasses=""
      @close="close"
    >
      <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
        Embedded Preview
      </h6>
      <!-- v-if="urlData.url.includes('https://')" -->
      <div>
        <iframe
          class="screenht450 w-full -mt-4"
          :src="url_data.url"
          frameborder="0"
          height="500"
          width="100%"
        ></iframe>
      </div>
      <template slot="footer">
        <!-- <base-button type="primary">SAVE CHANGES</base-button>
        <base-button @click="close" type="secondary" class="ml-auto"
          >CLOSE</base-button
        > -->
        <div class="hidden">helo</div>
      </template>
    </modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url_data: {},
    };
  },
  props: {
    urlData: {
      type: Object,
    },
    previewEmbedded: Boolean,
  },
  methods: {
    close() {
      this.$emit("close-previewAsses");
    },
  },
  watch: {
    urlData(newVal) {
      if (newVal) {
        this.url_data = { ...newVal };
        if (!this.url_data.url.includes("https://")) {
          this.url_data.url = "https://" + this.url_data.url;
          // console.log(this.url_data);
        }
      }
    },
  },
};
</script>
